

































import {Component, Prop, Vue} from 'vue-property-decorator';
import {HitDetectorWidgetIntervalType} from '@c/widgets/base/bindForms/enums';
import {hitDetectorWidgetIntervalTypes} from '@c/widgets/base/bindForms/configurate';
import DateTimePicker from '@c/controls/DateTimePicker.vue';

@Component({components: {DateTimePicker}})
export default class HitDetectorWidgetBindForm extends Vue {
  valid = true;

  @Prop({required: false})
  initIntervalType!: HitDetectorWidgetIntervalType;

  @Prop({required: false})
  initDate!: number;

  intervalType: HitDetectorWidgetIntervalType =
    this.initIntervalType || HitDetectorWidgetIntervalType.Days;

  date: number | undefined = this.initDate;

  changeDate(value: number) {
    this.date = value;
  }

  get intervalTypes() {
    return hitDetectorWidgetIntervalTypes;
  }
}
